import React from "react";
import { Panel, PanelType } from "@fluentui/react";
import { AnalysisPanel } from "./AnalysisPanel";
import { AnalysisPanelTabs } from "./AnalysisPanelTabs";
import { ChatAppResponse } from "../../api";
import { PriceSource } from "../../api/models";
import styles from "./AnalysisOverlay.module.css";

interface AnalysisOverlayProps {
    isOpen: boolean;
    onDismiss: () => void;
    answer: ChatAppResponse;
    activeTab: AnalysisPanelTabs;
    activeCitation?: string;
    citationHeight: string;
    onActiveTabChanged: (tab: AnalysisPanelTabs) => void;
    priceSource: PriceSource;
}

export const AnalysisOverlay: React.FC<AnalysisOverlayProps> = ({
    isOpen,
    onDismiss,
    answer,
    activeTab,
    activeCitation,
    citationHeight,
    onActiveTabChanged,
    priceSource
}) => {
    React.useEffect(() => {
        // Panel open/close state changed
    }, [isOpen]);

    React.useEffect(() => {
        // activeCitation changed
    }, [activeCitation]);

    return (
        <Panel
            className={styles.analysisPanelOverlay}
            isOpen={isOpen}
            onDismiss={() => {
                onDismiss();
            }}
            isBlocking={true}
            type={PanelType.custom}
            headerText="Analysis Panel"
            closeButtonAriaLabel="Close"
        >
            <div className={styles.analysisPanelContent}>
                <AnalysisPanel
                    activeCitation={activeCitation}
                    onActiveTabChanged={onActiveTabChanged}
                    citationHeight={citationHeight}
                    answer={answer}
                    activeTab={activeTab}
                    className=""
                    priceSource={priceSource}
                />
            </div>
        </Panel>
    );
};
